var createIconSetFromFontello = require('@expo/vector-icons')
  .createIconSetFromFontello;
var fontelloConfig = require('../../assets/darticon.json');

exports._icon = createIconSetFromFontello(fontelloConfig, 'darticon');
